import { Card } from 'react-bootstrap';
import classNames from 'classnames';
import Background from '@/components/common/Background';
import SubtleBadge from '@/components/common/SubtleBadge';
import { colorByScore, iconByScore } from './ScoreDisplayRenderer';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import MarkdownRenderer from './MarkdownRenderer';
import type { ReactNode } from 'react';

export type MetricsCardStat = {
  title?: ReactNode;
  value?: ReactNode;
  score?: number | null;
  tooltip?: string;
  badgeText?: string;
  badgeBg?: string;
  image?: string;
  className?: string;
};

type Props = {
  stat: MetricsCardStat;
  className?: string;
  [key: string]: unknown;
};

const MetricsCard = ({ stat, ...rest }: Props) => {
  const { title, value, score, tooltip, badgeText, badgeBg, image, className } =
    stat;
  return (
    <Card className={classNames(className, 'overflow-hidden')} {...(rest as object)}>
      <Background image={image} className="bg-card" />
      <Card.Body className="position-relative">
        <h6>
          {title}
          {tooltip && (
            <HelpTooltip
              styles={{ transform: 'scaleX(1)' }}
              className="mx-2"
              html={<MarkdownRenderer content={tooltip} />}
            />
          )}
          {badgeText && (
            <SubtleBadge bg={badgeBg} pill className="ms-2">
              {badgeText}
            </SubtleBadge>
          )}
        </h6>
        <div
          style={{ color: colorByScore(score) }}
          className={classNames(
            'display-6 fs-4 mb-2 fw-normal font-sans-serif'
          )}
        >
          <span className="me-2">{iconByScore(score)}</span>
          {value}
        </div>
      </Card.Body>
    </Card>
  );
};

export default MetricsCard;
